import React, {useState} from 'react';
import DatePicker from 'react-datepicker';
import {t} from 'i18next';
import {ContentWrapper, DatePickerLabel, DatePickerWrapper} from './StandardDatePicker.style';
import {getEffectiveDate} from '../../utils';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface StandardDatePickerProps {
    readonly date?: Date;
    readonly label: string;
    readonly initialize: boolean;
    readonly isClearable: boolean;
    readonly isNullable: boolean;
    readonly minDate?: Date;
    readonly maxDate?: Date;
    onChange: (date?: Date) => void;
}

const initializeDate = (date: Date | undefined, initialize: boolean) => {
    if (date) {
        return date;
    }

    if (initialize) {
        return getEffectiveDate();
    }

    return undefined;
};

export const StandardDatePicker: React.VFC<StandardDatePickerProps> = (props) => {
    const [dateSelection, setDateSelection] = useState<Date | undefined>(initializeDate(props.date, props.initialize));

    const onChangeHandler = (date: Date) => {
        let effectiveDate;
        if (date) {
            effectiveDate = date;
        } else if (props.isNullable) {
            effectiveDate = undefined;
        } else {
            effectiveDate = new Date();
        }

        setDateSelection(effectiveDate);
        props.onChange(effectiveDate);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            <DatePickerWrapper id={generateIdentifier()}>
                <DatePickerLabel id={generateIdentifier()}>{t(props.label)}</DatePickerLabel>
                <DatePicker id={generateIdentifier()}
                            selected={dateSelection}
                            onChange={onChangeHandler}
                            placeholderText={t('GENERAL_SELECT_DATE_TEXT')}
                            isClearable={props.isClearable}
                            minDate={props.minDate}
                            maxDate={props.maxDate}/>
            </DatePickerWrapper>
        </ContentWrapper>
    );
};
